import { type FC, useState } from 'react';
import { motion } from 'framer-motion';

import { IconsChevronDown } from '@/components/icons/IconsChevronDown';
import { IconsChevronUp } from '@/components/icons/IconsChevronUp';

type TProps = {
  title: JSX.Element;
  content: JSX.Element;
};
export const NavCollapsible: FC<TProps> = ({
  title,
  content,
}) => {
  const [isCollapsed, setCollapsed] = useState(true);
  const handleClick = () => {
    setCollapsed(!isCollapsed);
  };
  return (
    <>
      <>
        {title}
        <button
          className="collapsible-button"
          onClick={handleClick}
        >
          {isCollapsed ? (
            <IconsChevronDown />
          ) : (
            <IconsChevronUp />
          )}
          <motion.div
            className="background"
            style={{ opacity: 0 }}
            whileHover={{ opacity: 0.1 }}
          />
        </button>
      </>
      {!isCollapsed && (
        <>
          {content}
          <div style={{ height: '0.5rem' }} />
        </>
      )}
    </>
  );
};
